// import { createContext,useState } from "react";
// import img01 from "../img/img01.jpg";
// import img02 from "../img/img02.jpg"
// export const AdminFlagContext = createContext({});


// export const Flag =(props) => {
//     const {children}=props
//     //데이터 구조
//     //[{id: ,name: ,price: , url:}]


//     //플래그 만들기
//     const [date,setDate] =useState([]);
//     const [id,setID] =useState("");
//     const [arrays,setArrays] =useState([
//         {id:'1',name:'경복궁 생과방 체험[민속체험]' ,price:'15000',url:img02,info:"경복궁의 소주방 전각에 위치한 '생과방'은 궁중의 육처소 가운데 하나이며, '국왕과 왕비'의 후식과 별식을 준비하던 곳입니다. 경복궁 생과방 프로그램은 조선왕조실록의 내용을 토대로 실제 임금이 드셨던 궁중병과와 궁중약차를 오늘날에도 즐길 수 있도록 구성된 체험 프로그램입니다.",period:"2020-02-05 ~ 2020-03-07",number:"010-98438-0023",time:"08:00 ~ 15:00",address:"서울특별시 종로구 사직로 161"},
//         {id:'2',name:'배' ,price:'2500',url:img01,info:"사과이다",period:"2020-02-05 ~ 2020-03-07",number:"010-98438-0023",time:"08:00 ~ 15:00",address:"프랑스"},
//         {id:'3',name:'귤' ,price:'3500',url:img01,info:"사과이다",period:"2020-02-05 ~ 2020-03-07",number:"010-98438-0023",time:"08:00 ~ 15:00",address:"프랑스"}

//     ]);
//     //AdminFlagContext 안에 provider 이 있으으로 감싸면 된다
//     return (
//         <AdminFlagContext.Provider value={{date,setDate,id,setID,arrays,setArrays}}>
//             {children}
//         </AdminFlagContext.Provider>
//     )
// }

// import { createContext,useState } from "react";
// import img01 from "../img/img01.jpg";
// import img02 from "../img/img02.jpg";
// import img03 from "../img/img03.jpg"
// import product1_img1 from "../img/product1_img1.jpeg";
// import product1_img3 from "../img/product1_img3.jpeg";
// import product1_img2 from "../img/product1_img2.jpeg";
// import product2_img1 from "../img/product2_img1.jpeg";
// import product2_img2 from "../img/product2_img2.jpeg";
// import product2_img3 from "../img/product2_img3.jpeg";
// import product3_img1 from "../img/product3_img1.png";
// import product3_img2 from "../img/product3_img2.png";
// import product3_img3 from "../img/product3_img3.png";
// import product4_img1 from "../img/product4_img1.png";
// import product4_img2 from "../img/product4_img2.png";
// import product4_img3 from "../img/product4_img3.png";
// export const AdminFlagContext = createContext({});


// export const Flag =(props) => {
//     const {children}=props
//     //데이터 구조
//     //[{id: ,name: ,price: , url:}]


//     //플래그 만들기
//     const [date,setDate] =useState([]);
//     const [id,setID] =useState("");
//     const [arrays,setArrays] =useState([
//         {id:'1',
//         name:'UTOPIA:NOWHERE, NOW HERE' ,
//         price:'15000',
//         url:[product1_img1,product1_img2,product1_img3],
//         info:`국내최초 SF 작가의 소설을 기반으로 한 전시 세계관
//         김초엽 작가의 베스트셀러<<우리가 빛의 속도로 갈 수 없다면>>에 수록된 단편 <공생가설>을 각색한 스토리텔링에 따라 기획된 특별한 공간이 펼쳐집니다. 영화적 연출과 소설의 문법을 기반으로, 전시 그 이상의 감동을 마주해보세요.`,
//         period:"2024.03.29 ~ 2024.10.13",
//         number:"1522-1796",
//         time:"오전 10시 ~ 오후 7시",
//         address:"서울 성동구 아차산로17길 49 (성수동2가, 생각공장데시앙플렉스)지하1층 그라운드시소 "},
//         {id:'2',
//         name:'달리기 : 새는 날고 물고기는 헤엄치고 인간은 달린다' ,
//         price:'18000',
//         url:[product2_img3,product2_img1,product2_img2],
//         info:"일상에 활력을 더하는 달리기의 즐거움을 발견해보세요. 바쁜 생활 속에서도 건강한 삶을 가꾸고, 마음의 활력을 되찾는 의미 있는 변화를 경험하시길 바랍니다. 주제가 ‘달리기’인 만큼, 전시 관람의 드레스코드로 운동화 착용을 권장합니다.",
//         period:"2024.04.05 ~ 2024.07.28",
//         number:"02-6245-6371",
//         time:"오전 10시 ~ 오후 6시",
//         address:"피크닉(piknic) 서울 중구 퇴계로6가길 30(서울 중구 남창동 194)"},
//         {id:'3',
//         name:'귤' ,
//         price:'3500',
//         url:[product3_img1,product3_img2,product3_img3],
//         info:"사과이다",
//         period:"2020-02-05 ~ 2020-03-07",
//         number:"010-98438-0023",
//         time:"08:00 ~ 15:00",
//         address:"프랑스"},
//         {id:'4',
//         name:'귤',
//         price:'20000',
//         url:[product4_img1,product4_img2,product4_img3],
//         info:"",
//         period:"",
//         number:"",
//         time:"",
//         address:""}
//     ]);
//     //AdminFlagContext 안에 provider 이 있으으로 감싸면 된다
//     return (
//         <AdminFlagContext.Provider value={{date,setDate,id,setID,arrays,setArrays}}>
//             {children}
//         </AdminFlagContext.Provider>
//     )
// }
import { createContext,useState } from "react";
import product1_img1 from "../img/product1_img1.jpeg";
import product1_img3 from "../img/product1_img3.jpeg";
import product1_img2 from "../img/product1_img2.jpeg";
import product2_img1 from "../img/product2_img1.jpeg";
import product2_img2 from "../img/product2_img2.jpeg";
import product2_img3 from "../img/product2_img3.jpeg";
import product3_img1 from "../img/product3_img1.jpeg";
import product3_img2 from "../img/product3_img2.jpeg";
import product3_img3 from "../img/product3_img3.jpeg";
import product4_img1 from "../img/product4_img1.jpeg";
import product4_img2 from "../img/product4_img2.jpeg";
import product4_img3 from "../img/product4_img3.jpeg";
import product5_img1 from "../img/product5_img1.jpeg";
import product5_img2 from "../img/product5_img2.jpeg";
import product5_img3 from "../img/product5_img3.jpeg";
import product6_img1 from "../img/product6_img1.jpeg";
import product6_img2 from "../img/product6_img2.jpeg";
import product6_img3 from "../img/product6_img3.jpeg";
export const AdminFlagContext = createContext({});


export const Flag =(props) => {
    const {children}=props
    //데이터 구조
    //[{id: ,name: ,price: , url:}]


    //플래그 만들기
    const [date,setDate] =useState([]);
    const [id,setID] =useState("");
    const [arrays,setArrays] =useState([
        {id:'1',
        name:'UTOPIA:NOWHERE, NOW HERE' ,
        price:'15000',
        url:[product1_img1,product1_img2,product1_img3,product1_img1,product1_img1,product1_img1],
        info:`국내최초 SF 작가의 소설을 기반으로 한 전시 세계관
        김초엽 작가의 베스트셀러<<우리가 빛의 속도로 갈 수 없다면>>에 수록된 단편 <공생가설>을 각색한 스토리텔링에 따라 기획된 특별한 공간이 펼쳐집니다. 영화적 연출과 소설의 문법을 기반으로, 전시 그 이상의 감동을 마주해보세요.`,
        period:"2024.03.29 ~ 2024.10.13",
        number:"1522-1796",
        time:"10:00 ~ 19:00",
        address:"서울 성동구 아차산로17길 49 (성수동2가, 생각공장데시앙플렉스)지하1층 그라운드시소 "},
        {id:'2',
        name:'달리기 : 새는 날고 물고기는 헤엄치고 인간은 달린다' ,
        price:'18000',
        url:[product2_img3,product2_img1,product2_img2,product2_img3,product2_img3,product2_img3],
        info:"일상에 활력을 더하는 달리기의 즐거움을 발견해보세요. 바쁜 생활 속에서도 건강한 삶을 가꾸고, 마음의 활력을 되찾는 의미 있는 변화를 경험하시길 바랍니다. 주제가 ‘달리기’인 만큼, 전시 관람의 드레스코드로 운동화 착용을 권장합니다.",
        period:"2024.04.05 ~ 2024.07.28",
        number:"02-6245-6371",
        time:"10:00 ~ 18:00",
        address:"피크닉(piknic) 서울 중구 퇴계로6가길 30(서울 중구 남창동 194)"},
        {id:'3',
        name:'모네 인 서울' ,
        price:'15000',
        url:[product3_img1,product3_img2,product3_img3,product3_img1,product3_img1,product3_img1],
        info:"<모네 인 서울>은 음악, 모션그래픽, 엔지니어 등 각 분야의 아티스트들이 협업하여 제작한 스토리몰입형 미디어아트 전시입니다. 클로드 모네가 그린 150여점의 작품들과 프랑스인 현지 나레이션 녹음으로 기존 몰입형 미디어아트 형식에서 벗어난, 오직 띠아트에서만 경험할 수 있는 특별한 미디어아트 전시를 경험해보세요.",
        period:"2024.05.03 ~ 2024.07.30",
        number:"070-8829-9834",
        time:"11:00 ~ 20:00",
        address:"띠아트(THART)_홍대입구 서울특별시 마포구 와우산로21길 20-11 지층"},
        {id:'4',
        name:'마리아 스바르보바 사진전 : 어제의 미래',
        price:'18000',
        url:[product4_img1,product4_img2,product4_img3,product4_img1,product4_img1,product4_img1],
        info:"미래지향적이면서도 레트로적 감성을 자극하는, 작가만의 다양한 작품을 총망라하는 국내 최초 전시입니다. 다양한 매체와 전시 연출 방식으로 작가만의 트렌디한 감성을 느낄 수 있으며, 전시를 쉽게 이해하고 보다 깊이있게 즐길 수 있도록 다양한 교육 프로그램과 연계 이벤트도 개최될 예정입니다.",
        period:"2024.06.02 ~ 2024.09.30",
        number:"02-6273-4242",
        time:"10:00 ~ 19:00",
        address:"예술의 전당 한가람미술관 3층 서울 서초구 남부순환로 2406 (서초동 700)"},
        {id:'5',
        name:'데이비드 호크니 : Bigger & Closer' ,
        price:'27000',
        url:[product5_img1,product5_img2,product5_img3,product5_img1,product5_img1,product5_img1],
        info:"모두가 사랑하는 전세계 최고의 거장 ‘데이비드 호크니’의 몰입형 미디어 아트 전시를 서울에서 공개합니다.  “원근법 수업”, “호크니, 무대를 그리다.”, “도로와 보도”, “카메라로 그린 드로잉”, “수영장”, “가까이서 바라보기”와 같은 6가지 특별한 주제로 구성되었습니다.",
        period:"2023.11.01 ~ 2024.05.31",
        number:"02-3442-6460",
        time:"10:00 ~ 18:00",
        address:"라이트룸 서울(서울 강동구 아리수로61길 103)"},
        {id:'6',
        name:'어둠 속의 대화(DIALOGUE IN THE DARK)' ,
        price:'33000',
        url:[product6_img1,product6_img2,product6_img3,product6_img1,product6_img1,product6_img1],
        info:"보이는 것 그 이상을 보다, ‘어둠속의대화’는 1988년 독일에서 시작된 이후 유럽, 아시아, 미국 등 전 세계 160여개 지역에서 ‘100% 어둠 속 세상’이라는 이색적인 소재를 바탕으로 하여 전시와 퍼포먼스가 접목된 ‘Exhi-performance’라는 신개념의 종합예술로 진화한 국제적인 전시 프로젝트입니다.",
        period:"2024.05 ~ 2024.06",
        number:"1877-6145",
        time:"10:00 ~ 19:00시",
        address:"서울시 종로구 복촌로 71(가회동)"},

    ]); 
    //AdminFlagContext 안에 provider 이 있으으로 감싸면 된다
    return (
        <AdminFlagContext.Provider value={{date,setDate,id,setID,arrays,setArrays}}>
            {children}
        </AdminFlagContext.Provider>
    )
}